<div class="error-container">
    <div class="background-overlay">
        <img src="assets/static/img/login-background.jpg" class="background-image" alt="BCNDATA" />
    </div>

    <div class="logo-header">
        <img src="assets/static/img/logo-bcndata.png" class="main-logo" alt="Logo" />
    </div>

    <div class="content-wrapper">
        <p class="status-title">Servicio no disponible</p>

        <p class="timer-text">Comprobación automática en {{ tiempoRestante }} segundos</p>

        <button class="retry-button" [disabled]="isLoading" (click)="onRetry()">Reintentar</button>
    </div>
</div>
